<template>
  <div class="container" v-cloak>
    <div class="flexr0c">
      <div class="company" v-if="platformType==1">
        <div class="flex-align-center companyImg">
          <img class="first-img" src="../../assets/imgs/home/company.png" alt />
          <span class="companyName">{{overage.user.realName}}</span>
          <img src="../../assets/imgs/home/certified.png" alt class="certified" />
          <img src="../../assets/imgs/home/qi.png" alt class="type" />
          <img src="../../assets/imgs/home/guan.png" alt class="type" />
          <img src="../../assets/imgs/home/kuang.png" alt class="type" />
        </div>
        <div class="companyLine">
          <span class="msgTitle">企业代码：</span>
          <span class="msgContent">{{overage.enterprise.enterpriseCode}}</span>
        </div>
        <div class="companyLine">
          <span class="msgTitle">手机号码：</span>
          <span class="msgContent">{{overage.user.phone}}</span>
        </div>
        <div class="companyLine">
          <span class="msgTitle">用户名称：</span>
          <span class="msgContent">{{overage.user.userName}}</span>
          <img src="../../assets/imgs/home/admin.png" alt class="admin" />
        </div>
        <div class="companyLine">
          <span class="msgTitle">最近登录：</span>
          <span class="msgContent">{{overage.lastLoginTime}}</span>
        </div>
      </div>
      <div class="company" v-if="platformType!=1">
        <div class="flex-align-center companyImg">
          <img class="first-img" src="../../assets/imgs/home/company.png" alt />
          <span class="companyName">{{overage.enterpriseName}}</span>
          <img src="../../assets/imgs/home/certified.png" alt class="certified" />
          <img src="../../assets/imgs/home/qi.png" alt class="type" />
          <img src="../../assets/imgs/home/guan.png" alt class="type" />
          <img src="../../assets/imgs/home/kuang.png" alt class="type" />
        </div>
        <div class="companyLine">
          <span class="msgTitle">企业代码：</span>
          <span class="msgContent">{{overage.enterpriseCode}}</span>
        </div>
        <div class="companyLine">
          <span class="msgTitle">手机号码：</span>
          <span class="msgContent">{{overage.phone}}</span>
        </div>
        <div class="companyLine">
          <span class="msgTitle">用户名称：</span>
          <span class="msgContent">{{overage.userName}}</span>
          <img src="../../assets/imgs/home/admin.png" alt class="admin" />
        </div>
        <div class="companyLine">
          <span class="msgTitle">最近登录：</span>
          <span v-if="overage.thisLoginTime" class="msgContent">{{overage.thisLoginTime}}</span>
        </div>
      </div>
      <div class="money-explain">
        <div class="item">
          <div class="top">资金说明</div>
          <div class="img-box flexrcc">
            <div class="flexc0c">
              <img src="../../assets/imgs/home/money-explain1.png" alt="">
              <div class="img-txt">企业总资金</div>
            </div>
            <div class="math-icon">=</div>
            <div class="flexc0c">
              <img src="../../assets/imgs/home/money-explain2.png" alt="">
              <div class="img-txt">交易预付资金</div>
            </div>
            <div class="math-icon">+</div>
            <div class="flexc0c">
              <img src="../../assets/imgs/home/money-explain3.png" alt="">
              <div class="img-txt">矿云通专款</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="capital" v-if="platformType==1">
      <div class="item">
        <div class="title">资产情况</div>
        <div class="flexr0c">
          <div class="item-box">
            <div class="top">企业总资金(元)</div>
            <div class="content">
              <div class="num num1">{{overage.allBalance}}</div>
              <div ref="piechart" class="chart-box"></div>
            </div>
          </div>
          <div class="item-box">
            <div class="top">交易预付资金(元)</div>
            <div class="content flexc0c">
              <div class="num num2">{{overage.tradeBalance}}</div>
              <div class="btn" @click="toPre">查看明细</div>
              <div class="sub-title">*用于平台预付资金客户矿产品交易支付</div>
              <div class="bank-box">
                <div class="flexr">
                  <div class="label">银行账号</div>
                  <div class="item-txt">{{overage.enterprise.bankAccount}}</div>
                </div>
                <div class="flexr">
                  <div class="label">开户行</div>
                  <div class="item-txt">{{overage.enterpriseBank}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item-box">
            <div class="top">矿云通专款(元)</div>
            <div class="content flexc0c">
              <div class="num num2">{{overage.kytBalance}}</div>
              <div class="btn" @click="toSpecial">查看明细</div>
              <div class="sub-title">*用于矿产调运合同税费支付</div>
              <div class="account-box">
                <div class="flexrbc charge">
                  <div class="charge-title">矿云通充值账户</div>
                  <div class="charge-btn">在线充值</div>
                </div>
                <div class="flexr">
                  <div class="label">账户名称</div>
                  <div class="item-txt" v-if="overage.debitCard">
                    {{overage.orgAreaExt.hostBankAccountName}}</div>
                  <div class="item-txt" v-else></div>
                </div>
                <div class="flexr">
                  <div class="label">银行账号</div>
                  <div class="item-txt">{{overage.debitCard}}</div>
                </div>
                <div class="flexr">
                  <div class="label">开户行</div>
                  <div class="item-txt" v-if="overage.debitCard">{{overage.orgAreaExt.hostBankName}}
                  </div>
                  <div class="item-txt" v-else></div>
                </div>
                <div class="tips">温馨提示：</div>
                <div class="tips">矿运纳税前需先向此矿云通账户充值</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="capital" v-if="platformType!=1">
      <div class="item">
        <div class="title">资产情况</div>
        <div class="flexr0c">
          <div class="item-box">
            <div class="top">企业总资金(元)</div>
            <div class="content">
              <div class="num num1">{{overage.balance}}</div>
              <div ref="piechart" class="chart-box"></div>
            </div>
          </div>
          <div class="item-box">
            <div class="top">交易预付资金(元)</div>
            <div class="content flexccc">
              <div class="not-open">暂未开启</div>
            </div>
          </div>
          <div class="item-box">
            <div class="top">矿云通专款(元)</div>
            <div class="content flexc0c">
              <div class="num num2">{{overage.balance}}</div>
              <div class="btn" @click="toSpecial">查看明细</div>
              <div class="sub-title">*用于矿产调运合同税费支付</div>
              <div class="account-box">
                <div class="flexrbc charge">
                  <div class="charge-title">矿云通充值账户</div>
                  <div class="charge-btn">在线充值</div>
                </div>
                <div class="flexr">
                  <div class="label">账户名称</div>
                  <div class="item-txt" v-if="overage.vaAccount">{{overage.hostBankAccountName}}</div>
                  <div class="item-txt" v-else></div>
                </div>
                <div class="flexr">
                  <div class="label">银行账号</div>
                  <div class="item-txt">{{overage.vaAccount}}</div>
                </div>
                <div class="flexr">
                  <div class="label">开户行</div>
                  <div class="item-txt" v-if="overage.vaAccount">{{overage.hostBankName}}</div>
                  <div class="item-txt" v-else></div>
                </div>
                <div class="tips">温馨提示：</div>
                <div class="tips">矿运纳税前需先向此矿云通账户充值</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="calendar1">
      <div class="item">
        <div class="top flexrbc">
          <div class="flexr0c btn-box" @click="switchType">
            <div class="btn" :class="type==1?'btn-active':''" data-type="1">交易预付资金明细</div>
            <div class="btn" :class="type==2?'btn-active':''" data-type="2">矿云通专款明细</div>
          </div>
          <div class="flexr0c more" @click="more" :style="{display:(showMore==0?'none':'flex')}">
            <div class="look-more">查看更多</div>
            <img src="../../assets/imgs/home/more.png" alt="">
          </div>
        </div>
        <div class="card flexrbc">
          <div class="calendar-item">
            <datePicker :options="calendarArr" class="calendar" @handleClickDay="handleClickDay" @handlePrevMonth="handlePrevMonth" @handleNextMonth="handleNextMonth" />
          </div>
          <div class="date-info">
            <div class="top-box">
              <div class="top">
                <div class="title">当前日期</div>
                <div class="date">{{chooseDay.replace('-','年').replace('-','月')}}日</div>
              </div>
            </div>
            <div class="bottom">
              <div v-show="type==1">
                <div class="flexr">
                  <div class="label">当日客户充值(元)</div>
                  <div class="value">{{prepayObj.sumInMoney}}</div>
                </div>
                <div class="flexr">
                  <div class="label">当日交易支付(元)</div>
                  <div class="value">{{prepayObj.sumOutMoney}}</div>
                </div>
              </div>
              <div v-show="type==2">
                <div class="flexr">
                  <div class="label">当日充值收入(元)</div>
                  <div class="value">{{specialObj.INCOME}}</div>
                </div>
                <div class="flexr">
                  <div class="label">当日其他收入(元)</div>
                  <div class="value">{{specialObj.OTHERINCOME}}</div>
                </div>
                <div class="flexr">
                  <div class="label">当日转账收入(元)</div>
                  <div class="value">{{specialObj.TRANSFER}}</div>
                </div>
                <div class="flexr">
                  <div class="label">当日过站扣税(元)</div>
                  <div class="value">{{specialObj.TAXSTATION}}</div>
                </div>
                <div class="flexr">
                  <div class="label">当日补扣税(元)</div>
                  <div class="value">{{specialObj.TAX}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  </div>
</template>

<script>
import datePicker from "../date-picker.vue";
import echarts from "echarts";
import {
  mapMutations
} from "vuex";
export default {
  name: "moneyManage",
  data () {
    return {
      type: 1,
      showMore: 0,
      chart: null,
      userInfo: {},
      overage: {},
      chooseDay: "",
      prepayObj: {},
      specialObj: {},
      platformType: -1, //判断登录的用户是企业平台（2）还是交易平台（1）
      overage: {
        kytBalance: "",
        allBalance: "",
        tradeBalance: "",
        orgAreaExt: {
          debitCard: "",
          hostBankName: "",
          hostBankAccountName: "",
        },
        user: {
          realName: "",
          userName: "",
          phone: "",
        },
        enterprise: {
          enterpriseCode: "",
        },
        lastLoginTime: "",
        thisLoginTime: ''
      },
      calendarArr: {
        type: "combination",
        headStyle: {
          todayBtn: "right",
          combination: "center",
          checkBtn: "right",
        },
        viewStyle: {
          day: "center",
        },
        calendarData: [],
      },
    };
  },
  mounted () {
    this.initChart();
  },
  beforeDestroy () {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    ...mapMutations(["setContentType"]),
    padding0 (value) {
      return value.toString().padStart(2, 0);
    },
    toPre () {
      this.setContentType(4);
    },
    toSpecial () {
      this.setContentType(5);
    },
    toCharge () {
      this.setContentType(6);
    },
    handleClickDay () { },
    handlePrevMonth () { },
    handleNextMonth () { },
    switchType (e) {
      e.target.dataset.type == 1 ? (this.type = 1) : (this.type = 2);
      e.target.dataset.type == 2 ? (this.type = 2) : (this.type = 1);
      if (e.target.dataset.type == 1) {
        this.showMore = 0;
      }
      if (e.target.dataset.type == 2) {
        this.showMore = 1;
      }
    },
    more () {
      this.type == 1 ? this.setContentType(4) : this.setContentType(5);
    },
    dateFormat (fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    initChart () {
      this.chart = echarts.init(this.$refs.piechart);
      this.chart.setOption({
        color: ["#2C59C3", "#27AE60"],
        legend: {
          show: true,
          orient: "vertical",
          top: "40%",
          height: 280,
        },
        series: {
          label: {
            normal: {
              position: "inner",
              show: false,
            },
          },
          startAngle: 120,
          grid: {
            top: "10%",
            bottom: "0",
            left: "",
            right: "",
            height: "90%",
          },
          type: "pie",
          center: ["50%", "50%"],
          radius: [60, 75],
          data: [{
            name: "矿云通专款",
            value: 0,
          },
          {
            name: "交易预付资金",
            value: 100,
          },
          ],
        },
      });
    },
    handleClickDay (item) {
      this.chooseDay =
        item.year +
        "-" +
        item.month.toString().padStart(2, 0) +
        "-" +
        item.day.toString().padStart(2, 0);
      this.type == 1 ? this.tableLeft() : this.tableRight();
    },
    getUserInfo () {
      var session = JSON.parse(localStorage["session"]);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "7e6OAiAvmLIjmLrJ5cpGKzjEhNJJhPWc",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.userInfo = res.data;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    //交易中心获取企业总资金余额
    getOverage () {
      var session = JSON.parse(localStorage["session"]);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "y8Fd2a4VrB6OS4ggHVI4mPVvkosoTbAX",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.overage = res.data;
          this.chart.setOption({
            series: {
              data: [{
                name: "矿云通专款",
                value: res.data.kytBalance > 0 ? res.data.kytBalance : 0,
              },
              {
                name: "交易预付资金",
                value: res.data.tradeBalance > 0 ? res.data.tradeBalance : 0,
              },
              ],
            },
          });
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    //企业中心获取企业总资金余额
    getComBalance () {
      var session = JSON.parse(localStorage["session"]);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: "f5Ov1SBh0ZGcO01FV5ZbVsSgyfZqPvb7",
        type: "money",
        pageSize: 100,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.overage = res.data;
          if (this.overage.accountState == 1) {
            this.overage.name_of_collection_account = "";
            this.overage.opening_bank_name = "";
          }
          this.chart.setOption({
            series: {
              data: [{
                name: "矿云通专款",
                value: 1,
              },
              {
                name: "交易预付资金",
                value: 0,
              },
              ],
            },
          });
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    tableLeft () {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "mthTkE21VWLw4OpHVHFSVNgTF0sZeJpL",
        queryDay: this.chooseDay,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          for (let key in res.data) {
            res.data[key] = res.data[key].toFixed(2);
          }
          this.prepayObj = res.data;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    tableRight () {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "kf5jLomB0yfzl8hKFknclMhRehIQU605",
        queryDay: this.chooseDay,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          for (let key in res.data) {
            res.data[key] = res.data[key].toFixed(2);
          }
          this.specialObj = res.data;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    getPage (index) {
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "djC1X8ZxsJU5rvPRYVIPYdbF6PWDm1sn",
        pageIndex: index,
        pageSize: 10,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.count;
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
  },
  created () {
    this.chooseDay = this.dateFormat("YYYY-mm-dd", new Date());
    this.platformType = localStorage.getItem("platformMode")
    this.platformType == 1 ? this.getOverage() : this.getComBalance();
    // 如果是2判断为企业平台，默认不展示显示更多，点击切换按钮显示
    if (this.platformType == 2) {
      this.showMore = 0;
    }
    if (this.platformType == 1) {
      this.showMore = 1;
    }
    this.tableLeft();
    this.tableRight();
    // this.getPage(1)
  },
  components: {
    datePicker,
  },
};
</script>

<style lang="less" scoped>
[v-cloak] {
  display: none !important;
}

.container {
  width: 980px;
  margin-left: 20px;
  position: relative;

  .company {
    width: 570px;
    height: 220px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-bottom: 10px;

    .companyImg {
      .first-img {
        margin: 20px;
        margin-bottom: 10px;
      }

      .type {
        margin-right: 8px;
      }
    }

    .companyName {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 600;
    }

    .certified {
      margin: 0 4px;
    }

    .companyLine {
      margin: 5px 20px;

      .msgTitle {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #8b93a7;
        letter-spacing: 0;
      }

      .msgContent {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #4a4a4a;
        letter-spacing: 0;
      }

      .admin {
        margin: 0 5px;
        vertical-align: middle;
      }
    }
  }

  .money-explain {
    width: 400px;
    height: 220px;
    margin-left: 10px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-bottom: 10px;

    .item {
      width: 360px;
      height: 100%;
      margin-left: 20px;

      .top {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.4px;
        padding: 10px 0;
        border-bottom: 1px solid rgba(151, 151, 151, 0.1);
        margin-bottom: 23px;
      }

      .img-box {
        img {
          width: 70px;
          height: 70px;
          margin-bottom: 16px;
        }

        .img-txt {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #8b93a7;
          letter-spacing: 0.35px;
        }

        .math-icon {
          margin: 0 15px;
          color: #3b8686;
          margin-bottom: 35px;
        }
      }
    }
  }

  .capital {
    width: 980px;
    height: 500px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    .item {
      width: 940px;
      margin: 0 20px;

      .title {
        width: 100%;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0.4px;
        padding: 14px 0 4px 0;
        border-bottom: 1px solid rgba(151, 151, 151, 0.1);
      }

      .item-box {
        width: 300px;
        height: 400px;
        margin-top: 30px;
        margin-right: 20px;
        background: #ffffff;
        box-shadow: 0 4px 14px 0 rgba(37, 38, 94, 0.08);
        border-radius: 10px;

        &:hover {
          box-shadow: 0 4px 14px 0 rgba(37, 38, 94, 0.17);
        }

        .top {
          background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
          border-radius: 10px 10px 0 0;
          text-align: center;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #8b93a7;
          letter-spacing: 0.37px;
          width: 300px;
          height: 30px;
          line-height: 30px;
        }

        .content {
          width: 100%;

          .not-open {
            font-family: PingFangSC-Semibold;
            font-size: 30px;
            color: #e9e9e9;
            letter-spacing: 0;
            margin: 110px 80px 90px 80px;
          }

          .tips2 {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #616c84;
            margin-left: 25px;
          }

          .num {
            margin: 40px 0 0 0;
            font-family: PingFangSC-Semibold;
            font-size: 30px;
            text-align: center;
          }

          .num1 {
            color: #ff9000;
          }

          .num2 {
            color: #27ae60;
          }

          .num3 {
            color: #2c59c3;
          }

          .chart-box {
            width: 300px;
            height: 280px;
          }

          .btn {
            width: 80px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0.3px;
            background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
            border: 1px solid #285ed3;
            border-radius: 4px;
            margin: 10px 0 10px 0;
            cursor: pointer;

            &:hover {
              background-image: linear-gradient(
                180deg,
                #5295f5 0%,
                #2559d1 99%
              );
            }
          }

          .sub-title {
            width: 300px;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 15px;
            color: #af2534;
            padding-bottom: 10px;
            border-bottom: 1px dashed #ebedf3;
          }

          .bank-box {
            width: 230px;
            height: 26px;
            margin-top: 47px;

            & > div {
              margin-bottom: 4px;
            }
          }

          .account-box {
            width: 250px;

            & > div {
              margin-bottom: 4px;
            }

            .charge {
              margin: 10px 0;

              .charge-title {
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #8b93a7;
                letter-spacing: 0.35px;
              }

              .charge-btn {
                background-image: linear-gradient(
                  0deg,
                  #c6cfd6 0%,
                  #f5f6f8 100%
                );
                border: 1px solid #e9e9e9;
                border-radius: 4px;
                font-family: PingFangSC-Medium;
                font-size: 12px;
                color: #aeb3b7;
                letter-spacing: 0.3px;
                width: 80px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                // cursor: pointer;
              }
            }

            .tips {
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #616c84;

              &:first-child {
                display: inline-block;
                text-align: justify;
                text-align-last: justify;
                width: 58px;
              }
            }
          }

          .label {
            width: 62px;
            height: 20px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #8b93a7;
            letter-spacing: 0.35px;
            margin-right: 4px;
            display: inline-block;
            text-align: justify;
            text-align-last: justify;
            margin-right: 8px;
          }

          .item-txt {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #25265e;
            letter-spacing: 0.3px;
            width: 174px;
          }
        }
      }
    }
  }

  .calendar1 {
    margin-top: 10px;
    width: 980px;
    height: 442px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;

    .item {
      width: 942px;
      margin: 15px 20px;

      .top {
        .btn-box {
          width: 630px;
          height: 40px;
          line-height: 40px;
          border: 1px solid #2c59c3;
          border-radius: 4px;

          .btn {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #2c59c3;
            text-align: center;
            flex: 1;
            cursor: pointer;
          }

          .btn-active {
            background: #2c59c3;
            color: #fff;
          }
        }

        .more {
          cursor: pointer;

          .look-more {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #2c59c3;
            letter-spacing: 0.35px;
            text-align: right;
            margin-right: 5px;
          }
        }
      }

      .card {
        width: 100%;
        height: 340px;
        margin-top: 15px;

        .calendar-item {
          width: 630px;
          height: 340px;
        }

        .date-info {
          width: 300px;
          height: 340px;
          background: #ffffff;
          box-shadow: 0 4px 24px 0 rgba(37, 38, 94, 0.1);
          border-radius: 10px;

          .top-box {
            height: 132px;
            border-bottom: 1px dashed #ebedf3;
            overflow: hidden;

            .top {
              width: 210px;
              height: 50px;
              margin: 53px 45px;

              .title {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #616c84;
                letter-spacing: 0;
              }

              .date {
                font-family: PingFangSC-Medium;
                font-size: 18px;
                color: #2c59c3;
                letter-spacing: 0;
              }
            }
          }

          .bottom {
            // width: 210px;
            width: 100%;
            margin: 30px 45px;

            .label {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #8b93a7;
              letter-spacing: 0;
              margin-right: 5px;
              width: 140px;
              margin-bottom: 6px;
              display: inline-block;
              text-align: justify;
              text-align-last: justify;
              margin-right: 8px;
            }

            .value {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #2c59c3;
              letter-spacing: 0;
            }
          }
        }
      }
    }
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }
}
</style>
